import React from 'react';
import {setAppMessage} from '../../../app-actions.js';
import { MessageTypes } from "../../../app-constants/index.js";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  state = { error: null, errorInfo: null };

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo
    })
    // You can also log error messages to an error reporting service here
  }

  redirectToStoriesPage = () => this.props.history.push('/stories');

  render() {
    if (this.state.errorInfo) {

      // Error path
      return (
        <div>
          <div style={{textAlign: 'center'}}>Unknown Error.</div>
        </div>
      );

    }
    // Normally, just render children
    return this.props.children;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setAppMessage: (message, options) => dispatch(setAppMessage(message, options))
  }
}

export default withRouter(connect(null, mapDispatchToProps)(ErrorBoundary));
